import type { TOC } from '@ember/component/template-only'
import { hash } from '@ember/helper'
import {
  type CellObject,
  type ColumnObject,
  type RowObject,
  type TableMeta,
} from 'teacher-ui-client/components/stable-table/basic-table/cell'
import type { Config } from 'teacher-ui-client/components/stable-table/basic-table'

interface Signature {
  Element: HTMLTableCellElement
  Args: {
    columnObject: ColumnObject
    rowObject: RowObject
    rowIndex?: number
    cellObject: CellObject
    cellIndex: number
    config?: Config
  }
  Blocks: {
    default: [TableMeta]
  }
}

/**
 * Like cell component, just using <th/>, note: cellObject / columnObject are equal here
 */
export const BasicTableHeadCell: TOC<Signature> = <template>
  <th data-test-basic-table-cell={{@cellIndex}} class={{@cellObject.classNames}} ...attributes>
    {{#let
      (hash
        cellObject=@cellObject
        columnObject=@columnObject
        rowObject=@rowObject
        cellIndex=@cellIndex
        rowIndex=@rowIndex
        config=@config
      )
      as |tableMeta|
    }}
      {{#if (has-block)}}
        {{yield tableMeta}}
      {{else if @cellObject.component}}
        {{#let (component @cellObject.component) as |CellComponent|}}
          <CellComponent class={{@cellObject.componentClassNames}} @tableMeta={{tableMeta}} @isHeader={{true}} />
        {{/let}}
      {{else}}
        {{@cellObject.value}}
      {{/if}}
    {{/let}}
  </th>
</template>

export default BasicTableHeadCell
